import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../Api/dataApi";
import "./PlaceItem.css";

const PlaceItem = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    location: "",
    category: "Family", // القيمة الافتراضية
    condition: "",
    subcategory: "",
    images: [],
    brand: "",
    modelYear: "",
    km: "",
    engineCC: "",
    fuelType: "",
    transmission: "",
    drivetrain: "",
    doors: "",
    datePosted: new Date().toISOString(),
  });

  const wordLimits = {
    brand: 1,
    title: 2,
    location: 2,
    description: 1000,
    drivetrain: 3,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const limit = wordLimits[name];
    const words = value.split(/[\s]+/).filter(Boolean);

    if (limit && words.length > limit) {
      const errorMessage = t("word_limit", { limit, name: t(name) });
      alert(errorMessage);
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 5) {
      alert("You can upload up to 5 images only.");
      return;
    }
    setFormData((prev) => ({ ...prev, images: files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = JSON.parse(localStorage.getItem("user"));
    const data = new FormData();
    if (userData) {
      data.append("sellername", userData.name);
      data.append("sellerid", userData.phone);
    }
    Object.entries(formData).forEach(([key, value]) => {
      if (key === "km") {
        value += t("km");
      }
      if (key === "images") {
        value.forEach((file) => data.append("images", file));
      } else {
        data.append(key, value);
      }
    });

    try {
      const response = await fetch(`${API_URL}`, {
        method: "POST",
        body: data,
      });
      if (response.ok) {
        alert(t("upload_item_button") + "!");
        setFormData({
          title: "",
          description: "",
          price: "",
          location: "",
          category: "Family",
          condition: "",
          subcategory: "",
          images: [],
          brand: "",
          modelYear: "",
          km: "",
          engineCC: "",
          fuelType: "",
          transmission: "",
          drivetrain: "",
          doors: "",
        });
      } else {
        const error = await response.json();
        alert(`Error: ${error.message}`);
      }
    } catch (err) {
      console.error("Error uploading item:", err);
      alert(t("failed_to_upload_item"));
    }
  };

  return (
    <div className="placeitem-container">
      <div className="form-container">
        <h1>{t("place_item_title")}</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div>
              <label>{t("title")}</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <label>{t("description")}</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <label>{t("price")}</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <label>{t("location")}</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <label>{t("category")}</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
              >
                <option value="Cars">Cars</option>
                <option value="Property">Property</option>
                <option value="Services">Services</option>
                <option value="Furniture">Furniture</option>
                <option value="Camping">Camping</option>
                <option value="Gifts">Gifts</option>
                <option value="Contracting">Contracting</option>
                <option value="Family">Family</option>
                <option value="Animals">Animals</option>
                <option value="Electronics">Electronics</option>
                <option value="Other">Other</option>
                <option value="Job">Job</option>
              </select>
            </div>
            <div>
              <label>{t("condition")}</label>
              <input
                type="text"
                name="condition"
                value={formData.condition}
                onChange={handleInputChange}
                required
              />
            </div>
            <div>
              <label>{t("subcategory")}</label>
              <input
                type="text"
                name="subcategory"
                value={formData.subcategory}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label>{t("images_label")}</label>
              <input
                type="file"
                name="images"
                multiple
                accept="image/*"
                onChange={handleImageChange}
              />
            </div>
            {formData.category === "Cars" && (
              <>
                <div>
                  <label>{t("brand")}</label>
                  <input
                    type="text"
                    name="brand"
                    value={formData.brand}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label>{t("modelYear")}</label>
                  <input
                    type="number"
                    name="modelYear"
                    value={formData.modelYear}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label>{t("km")}</label>
                  <input
                    type="number"
                    name="km"
                    value={formData.km}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label>{t("engineCC")}</label>
                  <input
                    type="number"
                    name="engineCC"
                    value={formData.engineCC}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label>{t("fuelType")}</label>
                  <select
                    name="fuelType"
                    value={formData.fuelType}
                    onChange={handleInputChange}
                  >
                    <option value="Petrol">{t("Petrol")}</option>
                    <option value="Diesel">{t("Diesel")}</option>
                    <option value="Electric">{t("Electric")}</option>
                  </select>
                </div>
                <div>
                  <label>{t("transmission")}</label>
                  <select
                    name="transmission"
                    value={formData.transmission}
                    onChange={handleInputChange}
                  >
                    <option value="Manual">Manual</option>
                    <option value="Automatic">Automatic</option>
                  </select>
                </div>
                <div>
                  <label>{t("drivetrain")}</label>
                  <input
                    type="text"
                    name="drivetrain"
                    value={formData.drivetrain}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label>{t("doors")}</label>
                  <input
                    type="number"
                    name="doors"
                    value={formData.doors}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </>
            )}
          </div>
          <button type="submit">{t("upload_item_button")}</button>
        </form>
      </div>
      {/*
      <div className="items-container">
        <button onClick={fetchItems}>See your Upload Item</button>
        <div id="itemsContainer">
          {items.length === 0 ? (
            <p>No items found. Try uploading some items!</p>
          ) : (
            items.map((item, index) => (
              <div key={index} className="item">
                {item.images.map((imageBase64, i) => (
                  <img key={i} src={imageBase64} alt={`Item ${i + 1}`} />
                ))}
                <div>
                  <strong>Title:</strong> {item.title}<br />
                  <strong>Description:</strong> {item.description}<br />
                  <strong>Price:</strong> ${item.price}<br />
                  <strong>Location:</strong> {item.location}<br />
                  <strong>Category:</strong> {item.category}<br />
                  <strong>Condition:</strong> {item.condition}<br />
                  <strong>Subcategory:</strong> {item.subcategory || 'N/A'}<br />
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      */}
    </div>
  );
};

export default PlaceItem;
